import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 英制单位查询
export function ImperialUnitsSettingQueryFunc(data) {
  return request({
    url: URL.sys.ImperialUnitsSettingQueryUrl,
    method: 'post',
    data
  })
}

// 英制单位保存
export function ImperialUnitsSettingSaveFunc(data) {
  return request({
    url: URL.sys.ImperialUnitsSettingSaveUrl,
    method: 'post',
    data
  })
}
